import { createFileRoute, redirect } from '@tanstack/react-router'

// Bare Alpha has no pane of its own — land on the first sub-tab.
export const Route = createFileRoute('/_app/dev-resources/transitions/one/item/alpha/')({
  beforeLoad: () => {
    throw redirect({ to: '/dev-resources/transitions/one/item/alpha/x' })
  },
})
